import { BufferGeometry, BufferAttribute, Points, ShaderMaterial, AdditiveBlending } from "three"
import vertexParticlesShader from '/shader/particlesShader/vertex.glsl'
import fragmentParticlesShader from '/shader/particlesShader/fragment.glsl'

const count = 80
export let particlesMaterial = null 

export const createParticles = (scene, renderer) =>{
    const particlesGeometry= new BufferGeometry()
    const positions = new Float32Array(count * 3)
    const scales = new Float32Array(count)
    const randomness = new Float32Array(count)

    for(let i=0; i < count * 3; i++){
        const i3 = i * 3
        positions[i3 + 0] = (- Math.random() * 0.1) - 0.76
        positions[i3 + 1] = (Math.random() * (0.7)) + 0.65
        positions[i3 + 2] = (-Math.random() * 0.3) - 0.52

        scales[i] = Math.random()
        randomness[i] = Math.random()
    }

    particlesGeometry.setAttribute('position', new BufferAttribute(positions, 3))
    particlesGeometry.setAttribute('aScale', new BufferAttribute(scales, 1))
    particlesGeometry.setAttribute('aRandomness', new BufferAttribute(randomness, 1))

    particlesMaterial= new ShaderMaterial({
        vertexShader: vertexParticlesShader, 
        fragmentShader: fragmentParticlesShader, 
        uniforms: {
            uSize: {value: 70 * renderer.getPixelRatio()},
            uTime: {value: 0}
        },
        transparent: true,
        depthWrite: false,
        blending: AdditiveBlending,
    })
    const particles = new Points(particlesGeometry, particlesMaterial)
    scene.add(particles)
}